import * as _4 from 'lodash4';
import { UpdateScreenDeviceCommand } from '../commands/update_screen_device_command';
import { TScreenDevice } from '../models/screen_device_model';

export class ScreenDeviceSubscriptionServant {
  constructor(private updateScreenDeviceCommand: UpdateScreenDeviceCommand) {
    window['HIP'].factory.queryOne('yi-layout-screen-query').instance.subscribe({
      mediaDeviceHook: (device: TScreenDevice) => {
        this.updateScreenDeviceCommand(device);
      }
    });
  }
}

angular.module('ng-screen-query').service('ngScreenDeviceSubscriptionServant', ScreenDeviceSubscriptionServant);



// WEBPACK FOOTER //
// ./app/vendor/screen-query/src/servants/screen_device_subscription_servant.ts